import { BaseAccount, RawAccount } from "./base";

export class CorporateAccount extends BaseAccount {
    coll_ref: string = "partner_accounts"
    partnerId: string;
}


